export const createSlug = (s: string) =>
  s
    .split(/\s/)
    .slice(0, 10)
    .join("-")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const calcArticles = (article: any): any => {
  const slug = createSlug(article.headline);

  if (article.children.length === 0) {
    return [{ slug, article }];
  }

  return article.children.reduce(
    (xs: any, x: any) => [...xs, ...calcArticles(x)],
    [{ slug, article }]
  );
};

/* Returns a flat array of each article (assument slugs are unique) */
export const dbToArticles = (db: any) => {
  /* eslint-disable-next-line */ // new Array() is required
  return db.reduce(
    (xs: any, x: any) => [...xs, ...calcArticles(x)],
    new Array()
  );
};

const getUrlsFromTable = (data: any) => {
  return [data.url]
    .concat(
      data.rows.reduce(
        (res: Array<string>, curr: any) =>
          res
            .concat([curr.level.url])
            .concat(curr.content.map((row: any) => row.url)),
        []
      )
    )
    .concat(data.footnotes.map((row: any) => row.url));
};

const getUrlsFromList = (data: any) => {
  return [data?.url].concat(
    data.children.reduce((res: Array<string>, curr: any) => {
      if (curr.type === "li") {
        if (curr?.innerlist !== undefined) {
          return res.concat(curr.url).concat(getUrlsFromList(curr.innerlist));
        }
        return res.concat(curr.url);
      } else if (curr.type === "list" || curr.type === "list") {
        return res.concat(getUrlsFromList(curr));
      } else {
        return res;
      }
    }, [])
  );
};

const getUrlsFromSpecialRRZJTable = (data: any) => {
  if (data.english) {
    return getUrlsFromEnglishSpecialRRZJTable(data);
  }

  const res = [data.url]
    .concat(
      data.children
        .filter((c: any) => c.level === "C1" || c.level === "C2")
        .reduce(
          (res: Array<string>, c: any) => {
            return res
              .concat([data.levels[c.level]])
              .concat([data.headline_urls["recepce"]])
              .concat(c.children["recepce"].map((i: any) => i.url))
              .concat([data.headline_urls["produkce"]])
              .concat(c.children["produkce"].map((i: any) => i.url))
              .concat([data.headline_urls["interakce"]])
              .concat(c.children["interakce"].map((i: any) => i.url))
              .concat([data.headline_urls["mediace"]])
              .concat(c.children["mediace"].map((i: any) => i.url))
              .concat([data.headline_urls["okolnosti, podmínky"]])
              .concat(c.children["okolnosti, podmínky"].map((i: any) => i.url));
          },
          [data.persons.zkuseny]
        )
    )

    .concat(
      data.children
        .filter((c: any) => c.level === "B1" || c.level === "B2")
        .reduce(
          (res: Array<string>, c: any) => {
            return res
              .concat([data.levels[c.level]])
              .concat([data.headline_urls["recepce"]])
              .concat(c.children["recepce"].map((i: any) => i.url))
              .concat([data.headline_urls["produkce"]])
              .concat(c.children["produkce"].map((i: any) => i.url))
              .concat([data.headline_urls["interakce"]])
              .concat(c.children["interakce"].map((i: any) => i.url))
              .concat([data.headline_urls["mediace"]])
              .concat(c.children["mediace"].map((i: any) => i.url))
              .concat([data.headline_urls["okolnosti, podmínky"]])
              .concat(c.children["okolnosti, podmínky"].map((i: any) => i.url));
          },
          [data.persons.samostatny]
        )
    )

    .concat(
      data.children
        .filter((c: any) => c.level === "A1" || c.level === "A2")
        .reduce(
          (res: Array<string>, c: any) => {
            return res
              .concat([data.levels[c.level]])
              .concat([data.headline_urls["recepce"]])
              .concat(c.children["recepce"].map((i: any) => i.url))
              .concat([data.headline_urls["produkce"]])
              .concat(c.children["produkce"].map((i: any) => i.url))
              .concat([data.headline_urls["interakce"]])
              .concat(c.children["interakce"].map((i: any) => i.url))
              .concat([data.headline_urls["mediace"]])
              .concat(c.children["mediace"].map((i: any) => i.url))
              .concat([data.headline_urls["okolnosti, podmínky"]])
              .concat(c.children["okolnosti, podmínky"].map((i: any) => i.url));
          },
          [data.persons.zaklady]
        )
    )

    .concat(data.footnotes.map((f: any) => f.url));

  return res;
};

const getUrlsFromEnglishSpecialRRZJTable = (data: any) => {
  const res = [data.url]
    .concat(
      data.children
        .filter((c: any) => c.level === "C1" || c.level === "C2")
        .reduce(
          (res: Array<string>, c: any) => {
            return res
              .concat([data.levels[c.level]])
              .concat([data.headline_urls["reception"]])
              .concat(c.children["reception"].map((i: any) => i.url))
              .concat([data.headline_urls["production"]])
              .concat(c.children["production"].map((i: any) => i.url))
              .concat([data.headline_urls["interaction"]])
              .concat(c.children["interaction"].map((i: any) => i.url))
              .concat([data.headline_urls["mediation"]])
              .concat(c.children["mediation"].map((i: any) => i.url))
              .concat([data.headline_urls["conditions"]])
              .concat(c.children["conditions"].map((i: any) => i.url));
          },
          [data.persons.zkuseny]
        )
    )

    .concat(
      data.children
        .filter((c: any) => c.level === "B1" || c.level === "B2")
        .reduce(
          (res: Array<string>, c: any) => {
            return res
              .concat([data.levels[c.level]])
              .concat([data.headline_urls["reception"]])
              .concat(c.children["reception"].map((i: any) => i.url))
              .concat([data.headline_urls["production"]])
              .concat(c.children["production"].map((i: any) => i.url))
              .concat([data.headline_urls["interaction"]])
              .concat(c.children["interaction"].map((i: any) => i.url))
              .concat([data.headline_urls["mediation"]])
              .concat(c.children["mediation"].map((i: any) => i.url))
              .concat([data.headline_urls["conditions"]])
              .concat(c.children["conditions"].map((i: any) => i.url));
          },
          data.english ? [] : [data.persons.samostatny]
        )
    )

    .concat(
      data.children
        .filter((c: any) => c.level === "A1" || c.level === "A2")
        .reduce(
          (res: Array<string>, c: any) => {
            return res
              .concat([data.levels[c.level]])
              .concat([data.headline_urls["reception"]])
              .concat(c.children["reception"].map((i: any) => i.url))
              .concat([data.headline_urls["production"]])
              .concat(c.children["production"].map((i: any) => i.url))
              .concat([data.headline_urls["interaction"]])
              .concat(c.children["interaction"].map((i: any) => i.url))
              .concat([data.headline_urls["mediation"]])
              .concat(c.children["mediation"].map((i: any) => i.url))
              .concat([data.headline_urls["conditions"]])
              .concat(c.children["conditions"].map((i: any) => i.url));
          },
          [data.persons.zaklady]
        )
    )

    .concat(data.footnotes.map((f: any) => f.url));

  return res;
};

const getUrlsFromPopisyTable2 = (table: any) => {
  return [table.heading_1[0].url]
    .concat(
      table.rows[0].left.length ? getUrlsFromList(table.rows[0].left[0]) : []
    )
    .concat([table.heading_2[0].url])
    .concat(
      table.rows[0].right.length ? getUrlsFromList(table.rows[0].right[0]) : []
    );
};

const getUrlsFromPopisyTable1 = (table: any) => {
  return [table.url].concat(
    table.rows.reduce(
      (res: Array<string>, c: any) => {
        return res
          .concat(c.description.map((x: any) => x.url))
          .concat(c.czj.map((x: any) => x.url))
          .concat(c.cj.map((x: any) => x.url));
      },
      [table.url]
    )
  );
};

const getUrlsFromPars = (pars: any) => {
  return pars.reduce((res: Array<string>, current: any) => {
    if (current.type === "paragraph") {
      res.push(current.url);
      return res;
    } else if (current.type === "table") {
      return res.concat(getUrlsFromTable(current));
    } else if (current.type === "image") {
      return res.concat([current.url]);
    } else if (current.type === "list") {
      return res.concat(getUrlsFromList(current));
    } else if (current.type === "special RRZJ table") {
      return res.concat(getUrlsFromSpecialRRZJTable(current));
    } else if (current.type === "popisy-table-2") {
      return res.concat(getUrlsFromPopisyTable2(current));
    } else if (current.type === "popisy-table-2") {
      return res.concat(getUrlsFromPopisyTable1(current));
    } else {
      return res;
    }
  }, []);
};

export const getUrlArrayFromChapter = (data: any) => {
  return data
    .reduce((res: Array<string>, curr: any) => {
      const withHeadlineUrlAndPars = res
        .concat([curr.headline_url])
        .concat(getUrlsFromPars(curr.pars));
      if (curr.children === undefined) {
        return withHeadlineUrlAndPars;
      } else {
        return withHeadlineUrlAndPars.concat(
          getUrlArrayFromChapter(curr.children)
        );
      }
    }, [])
    .concat(
      data[0]?.references === undefined
        ? []
        : data[0].references.map((r: any) => r.url)
    );
};

export const nextVideo = (
  urlIndex: number,
  url: string,
  urlArray: string[],
  setUrlIndex: any
) => {
  let temporaryIndex = urlIndex;
  if (temporaryIndex < urlArray.length) {
    while (
      temporaryIndex < urlArray.length - 1 &&
      (urlArray[temporaryIndex] === url ||
        urlArray[temporaryIndex]?.length === 0 ||
        urlArray[temporaryIndex] === undefined ||
        urlArray[temporaryIndex].slice(0, 7) === "NOMATCH")
    ) {
      temporaryIndex++;
    }
    if (
      !(
        urlArray[temporaryIndex] === url ||
        urlArray[temporaryIndex]?.length === 0 ||
        urlArray[temporaryIndex] === undefined ||
        urlArray[temporaryIndex].slice(0, 7) === "NOMATCH"
      )
    ) {
      setUrlIndex(temporaryIndex);
    }
  }
};

export const previousVideo = (
  urlIndex: number,
  url: string,
  urlArray: string[],
  setUrlIndex: any
) => {
  let temporaryIndex = urlIndex;
  if (temporaryIndex < urlArray.length) {
    while (
      temporaryIndex > 0 &&
      (urlArray[temporaryIndex] === url ||
        urlArray[temporaryIndex] === undefined ||
        urlArray[temporaryIndex]?.length === 0 ||
        urlArray[temporaryIndex].slice(0, 7) === "NOMATCH")
    ) {
      temporaryIndex--;
    }
    setUrlIndex(temporaryIndex);
  }
};

const reduceFunc = (res: Array<any>, curr: any) => {
  if (curr.children?.length) {
    return [...res, curr, ...curr.children.reduce(reduceFunc, [])];
  } else {
    return [...res, curr];
  }
};

export const getMembers = (members: Array<any>) => {
  return members.reduce(reduceFunc, []);
};
